import React, { forwardRef } from 'react';
import PinInput from 'react-pin-input';

const PinField = forwardRef(({ onComplete, inputStyle = {} }, ref) => {
  const settings = {
    inputStyle: {
      borderRadius: '4px',
      fontSize: '19px',
      color: '#677882',
      fontWeight: 'bold',
      height: '45px',
      width: '40px',
      marginLeft: '5px',
      marginRight: '5px',
      paddingTop: '2px',
      paddingLeft: '2px',
      border: '1px solid #BCCAD2',
      ...inputStyle,
    },
    inputFocusStyle: {
      border: '1px solid #4C94D7',
      boxShadow: '0px 1px 6px rgba(11, 153, 230, 0.4)',
    },
  };

  return (
    <PinInput
      length={4}
      focus
      type='numeric'
      pattern='[0-9]*'
      inputMode='number'
      autocomplete='one-time-code'
      id='alpineIqPinInput'
      ref={ref}
      onComplete={(value, _) => {
        onComplete(value);
      }}
      {...settings}
    />
  );
});

export default PinField;
